var De = Object.defineProperty;
var Ne = (e, o, n) => o in e ? De(e, o, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[o] = n;
var oe = (e, o, n) => (Ne(e, typeof o != "symbol" ? o + "" : o, n), n);
import Ie from "intl-messageformat";
import { isNil as T, isString as Z, isFunction as K, isBoolean as se, isUndefined as He, pickBy as Ue, get as qe, set as Je, camelCase as me } from "lodash-es";
import { isProxy as Be, reactive as Y, defineComponent as z, shallowReactive as Q, onUnmounted as we, set as V, h as $, shallowRef as ce, ref as U, computed as D, provide as ae, inject as Ve, getCurrentInstance as ke, onBeforeMount as ve, toRaw as Ke, isRef as Ge, onMounted as Ee, onBeforeUpdate as Ce, onUpdated as We, onBeforeUnmount as je, onErrorCaptured as Re } from "vue";
import { isJSExpression as k, isJSFunction as ie, isI18nData as ee, TransformStage as G, isJSSlot as X, isDOMText as Xe, isNodeSchema as Ye } from "@alilc/lowcode-types";
import { useRendererContext as Pe, getCurrentNodeKey as ze, getRendererContextKey as Ze } from "@didi/fuxi-lowcode-vue-hooks";
import { debounce as Qe, exportSchema as et } from "@didi/fuxi-lowcode-vue-utils";
const de = {
  __scope: {
    type: Object,
    default: void 0
  },
  __rerender: {
    type: Function,
    default: () => ({})
  },
  __schema: {
    type: Object,
    required: !0
  },
  __designMode: {
    type: String,
    default: "live"
  },
  __components: {
    type: Object,
    required: !0
  },
  __locale: {
    type: String,
    default: void 0
  },
  __messages: {
    type: Object,
    default: () => ({})
  },
  __requestHandlersMap: {
    type: Object,
    default: () => ({})
  },
  __getNode: {
    type: Function,
    required: !0
  },
  __triggerCompGetCtx: {
    type: Function,
    required: !0
  }
}, Nt = Object.keys(
  de
), Le = {
  comp: {
    type: Object,
    default: void 0
  },
  scope: {
    type: Object,
    default: () => ({})
  },
  schema: {
    type: Object,
    default: () => ({})
  }
}, It = Object.keys(de);
function tt(e, o = {}, n = "zh-CN", i = {}) {
  return !i || !i[n] || !i[n][e] ? "" : new Ie(i[n][e], n).format(o);
}
function fe(e) {
  return !T(e) && typeof e == "object";
}
function te(e) {
  return !T(e) && Object.prototype.toString.call(e) === "[object Object]";
}
function ue(e) {
  return "$" in e;
}
function nt(e) {
  return !e || !fe(e) ? !1 : !!(ue(e) || Object.keys(e).length > 0);
}
function pe(...e) {
  const o = [];
  if (e.flat().forEach((u) => {
    nt(u) && o.push(u);
  }), o.length <= 1)
    return o[0];
  const [n, ...i] = o;
  return i.reduce((u, _) => {
    if (ue(_)) {
      if (ue(u))
        return _;
      {
        const p = u;
        u = _, _ = p;
      }
    }
    const b = Object.getOwnPropertyDescriptors(_);
    return u = Object.create(u, b), Be(_) ? Y(u) : u;
  }, n);
}
function I(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
const ot = {
  JSEXPRESSION: "JSExpression",
  JSFUNCTION: "JSFunction",
  JSSLOT: "JSSlot",
  JSBLOCK: "JSBlock",
  I18N: "i18n"
};
function rt() {
  try {
    return window.parent !== window && window.parent.location.host === window.location.host;
  } catch {
    return !1;
  }
}
function le(e, o) {
  const n = (i) => i.params ? `this.i18n('${i.key}', ${i.params.replace(
    /((\W|$)+)("|')(this\.[^'"]+)("|')(,)?/g,
    (u, _, b, p, h, m, g) => _ + h + (g || "")
  )})` : `this.i18n('${i.key}')`;
  return ne(
    {
      type: ot.JSEXPRESSION,
      value: n(e)
    },
    o
  );
}
function ne(e, o) {
  try {
    const n = ['"use strict";', "var __self = arguments[0];"];
    n.push("return ");
    let i;
    return i = (e.value || "").trim(), i = i.replace(
      /this(\W|$)/g,
      (u, _) => `__self${_}`
    ), i = n.join(`
`) + i, rt() && window.parent.__newFunc ? window.parent.__newFunc(i)(self) : new Function("$scope", `with($scope || {}) { ${i} }`)(o);
  } catch (n) {
    console.warn("parseExpression.error", n, e, self);
    return;
  }
}
function x(e, o) {
  if (k(e) || ie(e))
    return ne(e, o);
  if (ee(e))
    return le(e, o);
  if (Z(e))
    return e.trim();
  if (Array.isArray(e))
    return e.map((n) => x(n, o));
  if (K(e))
    return e.bind(o);
  if (te(e)) {
    if (!e)
      return e;
    const n = {};
    return Object.keys(e).forEach((i) => {
      i.startsWith("__") || (n[i] = x(e[i], o));
    }), n;
  }
  return e;
}
function re(e, o) {
  const n = {};
  return I(o).forEach((i, u) => {
    n[i] = e[u];
  }), n;
}
const Ae = {
  props: {
    name: {
      type: String,
      default: () => Math.floor(Date.now() * Math.random()).toString(16)
    }
  },
  render(e) {
    return e(
      "div",
      { style: { display: "contents" }, attrs: { fragment: this.name } },
      this.$slots.default
    );
  }
}, ge = (e) => e, st = (e) => e, ct = z({
  name: "Hoc",
  props: Le,
  setup(e) {
    const { triggerCompGetCtx: o } = Pe(), {
      node: n,
      locked: i,
      buildSchema: u,
      buildProps: _,
      buildSlots: b,
      buildLoop: p,
      buildShow: h
    } = _e(e), { show: m, hidden: g, condition: S } = h(e.schema), { loop: y, updateLoop: O, updateLoopArg: w, buildLoopScope: v } = p(
      e.schema
    ), j = u(), M = Q(j.props), L = Q(j.slots);
    if (n) {
      const F = [];
      we(() => F.forEach((A) => A == null ? void 0 : A())), F.push(
        n.onChildrenChange(() => {
          const A = n.export(G.Render);
          L.default = I(A.children);
        })
      ), F.push(
        n.onPropChange((A) => {
          const { key: R, prop: N, newValue: C, oldValue: J } = A, t = N.path.length === 1, r = N.path[0];
          if (t && R)
            if (R === "___isLocked___")
              i.value = C;
            else if (R === "___hidden___")
              g(C);
            else if (R === "___condition___")
              S(C);
            else if (R === "___loop___")
              O(C);
            else if (R === "___loopArgs___")
              w(C);
            else if (R === "children")
              if (X(C)) {
                const c = N.slotNode.export(G.Render);
                V(L, "default", c);
              } else
                T(C) ? delete L.default : V(L, "default", I(C));
            else if (X(C)) {
              const c = N.slotNode.export(G.Render);
              V(L, R, {
                ...c,
                slot: R
              });
            } else
              T(C) && X(J) ? delete L[R] : V(M, R, C);
          else
            r === "___loopArgs___" ? w(C, R) : r && V(M, r, n.getPropValue(r));
        })
      );
    }
    return {
      show: m,
      loop: y,
      compSlots: L,
      compProps: M,
      getRef: (F) => {
        o(e.schema, F);
      },
      buildSlots: b,
      buildProps: _,
      buildLoopScope: v
    };
  },
  unmounted() {
    console.log("unmounted");
  },
  render() {
    const {
      comp: e,
      show: o,
      loop: n,
      compProps: i,
      compSlots: u,
      getRef: _,
      buildSlots: b,
      buildProps: p,
      buildLoopScope: h
    } = this;
    if (!o)
      return null;
    if (!e)
      return $("div", "component not found");
    if (!n) {
      const m = p(i, null, { ref: _ }), g = b(u);
      return $(
        e,
        m,
        Object.keys(g || {}).map((S) => g == null ? void 0 : g[S]()).flat()
      );
    }
    return Array.isArray(n) ? $(
      Ae,
      n.map((m, g, S) => {
        const y = h(m, g, S.length), O = p(i, y, { ref: _ }), w = b(u, y), v = Object.keys(w || {}).map((j) => w == null ? void 0 : w[j](O.prop)).flat();
        return $(e, O, v);
      })
    ) : (console.warn("[vue-renderer]: loop must be array", n), null);
  }
}), it = z({
  props: Le,
  setup(e) {
    const { buildSchema: o, buildProps: n, buildLoop: i, buildSlots: u, buildShow: _ } = _e(e), { show: b } = _(e.schema), { loop: p, loopArgs: h, buildLoopScope: m } = i(e.schema), g = o(), S = Q(g.props), y = Q(g.slots);
    return {
      show: b,
      loop: p,
      loopArgs: h,
      compProps: S,
      compSlots: y,
      buildSlots: u,
      buildProps: n,
      buildLoopScope: m
    };
  },
  render() {
    const {
      show: e,
      comp: o,
      loop: n,
      compProps: i,
      compSlots: u,
      buildProps: _,
      buildSlots: b,
      buildLoopScope: p
    } = this;
    if (!e)
      return null;
    if (!o)
      return $("div", "component not found");
    if (!n) {
      const h = _(i), m = b(u);
      return $(
        o,
        h,
        Object.keys(m || {}).map((g) => m == null ? void 0 : m[g]()).flat()
      );
    }
    return Array.isArray(n) ? $(
      Ae,
      n.map((h, m, g) => {
        const S = p(h, m, g.length), y = _(i, S), O = b(u, S), w = Object.keys(O || {}).map((v) => O == null ? void 0 : O[v](y.prop)).flat();
        return $(o, y, w);
      })
    ) : (console.warn("[vue-renderer]: loop must be array", n), null);
  }
});
function xe(e) {
  const o = [];
  return Object.keys(e).forEach((n) => {
    const i = e[n];
    i == null || i === "" || (typeof i == "object" ? o.push(`${n}=${encodeURIComponent(JSON.stringify(i))}`) : o.push(`${n}=${encodeURIComponent(String(i))}`));
  }), o.join("&");
}
function ut(e, o) {
  if (!o)
    return e;
  const n = xe(o);
  return n ? e.indexOf("?") > 0 ? `${e}&${n}` : `${e}?${n}` : e;
}
function lt(e, o) {
  for (const n in e)
    if (n.toLowerCase() === o)
      return [e[n], n];
  return [];
}
function at(e) {
  return ["arrayBuffer", "blob", "formData", "json", "text"].includes(e);
}
function dt(e) {
  const o = new FormData();
  for (const n in e) {
    const i = e[n];
    i instanceof Blob ? o.append(n, i) : o.append(n, String(i));
  }
  return o;
}
const Se = {
  "application/json": (e) => JSON.stringify(e),
  "multipart/form-data": (e) => te(e) ? dt(e) : e,
  "application/x-www-form-urlencoded": (e) => xe(e)
};
function ft(e, o) {
  const n = Object.keys(Se).find(
    (i) => e.includes(i)
  );
  return n ? Se[n](o) : o;
}
class W extends Error {
  constructor(o, n, i) {
    super(o), this.code = n, this.data = i;
  }
}
class ye {
  constructor(o, n) {
    this.code = o, this.data = n;
  }
}
async function _t(e) {
  const {
    uri: o,
    method: n,
    timeout: i,
    params: u = {},
    headers: _ = {},
    responseType: b = "json"
  } = e;
  let p;
  const h = {
    Accept: "application/json",
    ..._
  }, m = {
    method: n,
    headers: h
  };
  if (n === "GET" || n === "DELETE" || n === "OPTIONS")
    p = ut(o, u);
  else {
    p = o;
    const [y, O] = lt(h, "content-type");
    m.body = ft(
      y != null ? y : "application/json",
      u
    ), y === "multipart/form-data" && O && delete h[O];
  }
  if (i) {
    const y = new AbortController();
    m.signal = y.signal, setTimeout(() => y.abort(), i);
  }
  const g = await fetch(p, m), S = g.status;
  if (S >= 200 && S < 300)
    if (S === 204) {
      if (n === "DELETE")
        return new ye(S, null);
      throw new W(g.statusText, S);
    } else {
      if (!at(b))
        throw new W(`invalid response type: ${b}`, -1);
      return new ye(S, await g[b]());
    }
  else if (S >= 400)
    try {
      const y = await g.json();
      throw new W(g.statusText, S, y);
    } catch {
      throw new W(g.statusText, S);
    }
  throw new W(g.statusText, S);
}
var B = /* @__PURE__ */ ((e) => (e.Initial = "init", e.Loading = "loading", e.Loaded = "loaded", e.Error = "error", e))(B || {});
const ht = (e) => e, mt = () => {
}, pt = () => !0;
function gt(e, o, n) {
  const i = ce(), u = ce(), _ = U(B.Initial), b = D(() => _.value === B.Loading), p = D(() => !!x(e.isInit, n)), { willFetch: h, shouldFetch: m, dataHandler: g, errorHandler: S } = e, y = {
    willFetch: h ? x(h, n) : ht,
    shouldFetch: m ? x(m, n) : pt,
    dataHandler: g ? x(g, n) : (w) => w.data,
    errorHandler: S ? x(S, n) : mt
  };
  return Y({
    data: i,
    error: u,
    loading: b,
    status: _,
    isInit: p,
    load: async (w, v = {}) => {
      try {
        const { type: j, options: M, id: L, requestHandlersMap: q = {} } = e, {
          headers: F,
          assignToScope: A = !0,
          ...R
        } = v;
        try {
          q && j && q[j] && (o = q[j]);
        } catch (c) {
          console.log(c);
        }
        if (!o)
          throw new Error("unsupport fetch type: " + j);
        if (!(K(y.shouldFetch) ? y.shouldFetch() : se(y.shouldFetch) ? y.shouldFetch : !0))
          throw _.value = B.Error, new Error(
            `the ${L} request should not fetch, please check the condition`
          );
        const {
          params: C,
          headers: J,
          ...t
        } = x(M != null ? M : {}, n);
        _.value = B.Loading;
        const r = await o(
          y.willFetch({
            ...t,
            ...R,
            headers: {
              ...J,
              ...F
            },
            params: te(C) && te(w) ? {
              ...C,
              ...w
            } : w != null ? w : C
          })
        );
        _.value = B.Loaded;
        const l = i.value = y.dataHandler(r);
        return !He(i) && A && (n[L] = l), l;
      } catch (j) {
        throw _.value = B.Error, u.value = j, y.errorHandler(j), j;
      }
    }
  });
}
function St({ list: e = [], dataHandler: o }, n, i) {
  const u = {}, _ = {};
  return e.forEach((p) => {
    const h = { dataHandler: o, ...p, requestHandlersMap: i }, m = gt(h, _t, n), g = (S, y) => {
      const O = {
        assignToScope: !1,
        ...y
      };
      return m.load(S, O);
    };
    u[p.id] = g, _[p.id] = m;
  }), { dataSource: u, dataSourceMap: _, reloadDataSource: (p, h, m) => {
    if (p) {
      const S = _[p];
      if (!S)
        throw new Error("dataSource not found, id: " + p);
      return S.load(h, m);
    }
    const g = Object.keys(_).map((S) => _[S]).filter((S) => S.isInit).map((S) => S.load());
    return Promise.all(g);
  } };
}
const yt = ze(), bt = {
  beforeMount: ve,
  mounted: Ee,
  beforeUpdate: Ce,
  updated: We,
  beforeUnmount: je,
  unmounted: we,
  errorCaptured: Re
}, Ot = {
  componentDidMount: Ee,
  componentDidCatch: Re,
  shouldComponentUpdate: Ce,
  componentWillUnmount: je
}, $e = {
  ...bt,
  ...Ot
};
function wt(e) {
  return e in $e;
}
function Fe(e) {
  return Array.isArray(e) ? e.every((o) => Fe(o)) : Xe(e) || Ye(e) || k(e) || ee(e);
}
const be = Symbol("IS_LOCKED");
function vt(e) {
  const o = U(e), n = Ve(be, null), i = D({
    get: () => (n == null ? void 0 : n.value) || o.value,
    set: (u) => o.value = u
  });
  return ae(be, i), i;
}
const Et = ["onClick"];
function _e(e) {
  const { components: o, getNode: n, designMode: i } = Pe(), u = e.schema.id ? n(e.schema.id) : null, _ = u ? vt(u.isLocked) : U(!1), b = i === "design";
  ae(yt, {
    mode: i,
    node: u,
    isDesignerEnv: b
  });
  const p = (t, r, l, c) => {
    const s = pe(e.scope, l);
    if (Z(t))
      return ge(t);
    if (k(t)) {
      const a = ne(t, s);
      return ge(st(a));
    } else if (ee(t))
      return le(t, s);
    if (!c) {
      const { componentName: a } = t;
      c = o[a];
    }
    if (!c)
      return $("div", "component not found");
    const f = Ue(c, (a, d) => !!d.match(/^__[\s\S]+__/));
    return Object.keys(f).length > 0 && (r = Object.create(
      r,
      Object.getOwnPropertyDescriptors(f)
    )), $(r, {
      key: t.id,
      ...t.slot ? { slot: t.slot } : {},
      props: {
        comp: c,
        scope: s,
        schema: t
      }
    });
  }, g = b ? (t, r, l) => p(t, ct, r, l) : (t, r, l) => p(t, it, r, l), S = (t) => {
    var s;
    const r = t || (u ? u.export(G.Render) : e.schema), l = {}, c = {};
    return l.default = I(r.children), Object.entries((s = r.props) != null ? s : {}).forEach(([f, a]) => {
      if (X(a)) {
        const d = u == null ? void 0 : u.getProp(f);
        if (d && d.slotNode) {
          const E = d.slotNode.export(G.Render);
          l[f] = {
            ...E,
            slot: f
          };
        } else
          a.value && (l[f] = {
            componentName: "Slot",
            params: a.params,
            children: Array.isArray(a.value) ? a.value.map((E) => ({
              ...E,
              slot: f
            })) : {
              ...a.value,
              slot: f
            }
          });
      } else
        f === "className" ? c.class = a : f === "children" && Fe(a) ? l.default = I(a) : c[f] = a;
    }), b && (c.componentId = r.id), { props: c, slots: l };
  }, y = (t, r, l, c) => {
    var s, f;
    if (k(t) || ie(t))
      return ne(t, r);
    if (ee(t))
      return le(t, r);
    if (X(t)) {
      let a, d;
      return c != null && c.slotNode ? (d = c.slotNode.export(G.Render), a = (s = d.params) != null ? s : []) : (d = I(t == null ? void 0 : t.value), a = (f = t == null ? void 0 : t.params) != null ? f : []), (...E) => {
        const P = re(E, a), H = [];
        return I(d).forEach((Te) => {
          const he = g(Te, [l, P]);
          he && H.push(he);
        }), H;
      };
    } else {
      if (Array.isArray(t))
        return t.map(
          (a, d) => y(a, r, l, c == null ? void 0 : c.get(d))
        );
      if (t && fe(t)) {
        const a = {};
        return Object.keys(t).forEach((d) => {
          if (d.startsWith("__"))
            return;
          const E = t[d], P = c == null ? void 0 : c.get(d);
          a[d] = y(E, r, l, P);
        }), a;
      }
    }
    return t;
  }, O = (t, r, l, c) => {
    if (Z(t)) {
      const s = t;
      let f = null;
      return (a) => {
        const d = qe(r, "$.refs", {});
        if (d && Object.keys(d).length === 0 && Je(r, "$.refs", d), T(r.__loopRefIndex))
          d[s] = a, s in r && (r[s] = a);
        else {
          let E = d[s];
          if (!Array.isArray(E))
            E = d[s] = [], s in r && (E = r[s] = E);
          else if (s in r) {
            const P = r[s];
            !Array.isArray(P) || Ke(P) !== E ? E = r[s] = E : E = P;
          }
          if (T(a)) {
            const P = E.indexOf(f);
            P >= 0 && E.splice(P, 1);
          } else
            E[r.__loopRefIndex] = a;
        }
        f = a;
      };
    } else {
      const s = y(t, r, l, c);
      return Z(s) ? O(s, r, l, c) : s;
    }
  }, w = (t, r, l) => {
    var c;
    if (r.startsWith("v-model")) {
      const s = r.match(/v-model(?::(\w+))?$/);
      if (!s)
        return t;
      const f = me((c = s[1]) != null ? c : "value"), a = `onUpdate:${f}`;
      if (k(l)) {
        const d = {
          type: "JSFunction",
          value: `function ($event) {${l.value} = $event}`
        };
        t[a] = a in t ? I(t[a]).concat(d) : d;
      }
      t[f] = l;
    } else if (!(r.startsWith("v-") && k(l))) {
      if (!r.endsWith("sync"))
        if (r.match(/^on[A-Z]/) && ie(l)) {
          const s = r.match(/onUpdate(?::?(\w+))$/);
          s && (r = `onUpdate:${me(s[1])}`), t[r] = r in t ? I(t[r]).concat(l) : l;
        } else if (r === "ref" && "ref" in t) {
          const s = l, f = t.ref;
          K(f) && K(s) ? t.ref = (...a) => {
            s(...a), f(...a);
          } : t.ref = [f, s].filter(K).pop();
        } else
          t[r] = l;
    }
  }, v = (t, r, l) => {
    const c = {};
    Object.keys(t).forEach((a) => {
      w(c, a, t[a]);
    });
    const s = {}, f = r ? pe(e.scope, r) : e.scope;
    return Object.keys(c).forEach((a) => {
      const d = c[a];
      s[a] = a === "ref" ? O(
        d,
        f,
        r,
        u == null ? void 0 : u.getProp(a)
      ) : y(d, f, r, u == null ? void 0 : u.getProp(a));
    }), l && Object.keys(l).forEach((a) => {
      w(s, a, l[a]);
    }), q(s);
  }, j = ["id", "placeholder"], M = ["innerHTML", "p"], L = ["class", "style", "slot", "key", "ref"], q = (t) => {
    const { events: r, eventNameList: l } = A(t), c = {
      props: {},
      attrs: {},
      domProps: {},
      ...r
    };
    return Object.keys(t || {}).forEach((s) => {
      j.includes(s) ? c.attrs[s] = t == null ? void 0 : t[s] : M.includes(s) ? c.domProps[s] = t == null ? void 0 : t[s] : L.includes(s) ? c[s] = t == null ? void 0 : t[s] : l.includes(s) || (/^onUpdate:/.test(s) ? c.on = {
        ...c.on || {},
        input: t == null ? void 0 : t[s]
      } : c.props[s] = t == null ? void 0 : t[s]);
    }), c;
  }, F = /^on([A-Z])/, A = (t) => {
    var s;
    const l = (((s = t == null ? void 0 : t.__events) == null ? void 0 : s.eventDataList) || []).map((f) => f.name), c = {
      nativeOn: {},
      on: {}
    };
    return l.forEach((f) => {
      Et.includes(f) ? c.nativeOn[f.replace(F, (a, d) => d.toLowerCase())] = t == null ? void 0 : t[f] : c.on[f] = t == null ? void 0 : t[f];
    }), {
      events: c,
      eventNameList: l
    };
  }, R = (t) => {
    const r = U(), l = U(["item", "index"]);
    return t.loop && (r.value = Object.assign({}, t.loop)), t.loopArgs && t.loopArgs.forEach((c, s) => {
      l.value[s] = c;
    }), {
      loop: D(() => r.value ? x(r.value, e.scope) : null),
      loopArgs: l,
      updateLoop(c) {
        r.value = Object.assign({}, c);
      },
      updateLoopArg(c, s) {
        Array.isArray(c) ? c.forEach((f, a) => {
          l.value[a] = f;
        }) : T(s) || (l.value[s] = c);
      },
      buildLoopScope(c, s, f) {
        var H;
        const d = (H = e.scope.__loopRefOffset) != null ? H : 0, [E, P] = l.value;
        return {
          [E]: c,
          [P]: s,
          __loopScope: !0,
          __loopRefIndex: d + s,
          __loopRefOffset: f * s
        };
      }
    };
  }, N = (t) => {
    var s, f, a;
    const r = b ? U((s = t.hidden) != null ? s : !1) : U(!1), l = U(
      se((f = t.condition) != null ? f : !0) ? (a = t.condition) != null ? a : !0 : Object.assign({}, t.condition)
    );
    return {
      show: D(() => {
        if (r.value)
          return !1;
        const { value: d } = l;
        return typeof d == "boolean" ? d : !!x(d, e.scope);
      }),
      hidden: (d) => {
        r.value = !!d;
      },
      condition: (d) => {
        l.value = se(d) ? d : Object.assign({}, d);
      }
    };
  }, C = (t) => (...r) => {
    const l = t(...r);
    if (!l.length) {
      const c = _.value, s = {
        "lc-container-locked": c,
        "lc-container-placeholder": !0
      }, f = c ? "\u9501\u5B9A\u5143\u7D20\u53CA\u5B50\u5143\u7D20\u65E0\u6CD5\u7F16\u8F91" : "\u62D6\u62FD\u7EC4\u4EF6\u6216\u6A21\u677F\u5230\u8FD9\u91CC";
      l.push($("div", { class: s }, f));
    }
    return l;
  };
  return {
    node: u,
    locked: _,
    buildShow: N,
    renderComp: g,
    buildLoop: R,
    buildProps: v,
    buildSlots: (t, r) => Object.keys(t).reduce((l, c) => {
      const s = t[c], f = c === "default";
      if (T(s) || f && !(u != null && u.isContainer()) && Array.isArray(s) && s.length === 0)
        return l;
      let a;
      return Array.isArray(s) ? a = () => s.map((d) => g(d, r)).filter((d) => !T(d)) : s.id ? a = (...d) => {
        var P;
        const E = g(s, [
          r,
          re(d, (P = s.params) != null ? P : [])
        ]);
        return T(E) ? [] : [E];
      } : a = (...d) => {
        var P;
        const E = re(d, (P = s.params) != null ? P : []);
        return I(s.children).map((H) => g(H, [r, E])).filter((H) => !T(H));
      }, l[c] = f && b && (u == null ? void 0 : u.isContainer()) ? C(a) : a, l;
    }, {}),
    buildSchema: S
  };
}
function Ct(e) {
  const { scope: o } = jt(e), n = Y({
    comp: null,
    scope: o,
    schema: D(() => e.__schema)
  }), i = Ze(), u = D(() => e.__designMode), _ = D(() => e.__components);
  return ae(
    i,
    Y({
      designMode: u,
      components: _,
      getNode: (b) => {
        var p, h;
        return (h = (p = e.__getNode) == null ? void 0 : p.call(e, b)) != null ? h : null;
      },
      rerender: e.__rerender,
      triggerCompGetCtx: D(() => e.__triggerCompGetCtx)
    })
  ), { scope: o, designModeRef: u, componentsRef: _, ..._e(n) };
}
function jt(e) {
  var R, N, C, J, t;
  const {
    __schema: o,
    __scope: n,
    __requestHandlersMap: i
  } = e, {
    props: u,
    state: _,
    methods: b,
    lifeCycles: p
  } = o != null ? o : {}, { proxy: h } = ke(), m = h.$options;
  m.methods = {};
  const g = m.data = Y({}), S = (R = x(u)) != null ? R : {};
  Object.assign(m.props, S);
  const y = (N = x(_)) != null ? N : {};
  Object.keys(y).map((r) => {
    V(g, r, y[r]);
  });
  const O = (C = x(b, h)) != null ? C : {};
  Object.assign(m.methods, O);
  const w = x(p, h);
  fe(w) && Object.keys(w).forEach((r) => {
    if (wt(r)) {
      const l = w[r], c = $e[r];
      K(l) && c(l, h);
    }
  });
  let v = null;
  o.id && (v = document.querySelector(`style[data-id="${o.id}"]`)), o.css ? (v || (v = document.createElement("style"), o.id && v.setAttribute("data-id", o.id), (document.head || document.getElementsByTagName("head")[0]).appendChild(v)), v.innerHTML !== o.css && (v.innerHTML = o.css)) : v && ((J = v.parentElement) == null || J.removeChild(v));
  const j = (r) => {
    Object.keys(r).forEach((l) => {
      const c = r[l], s = Ge(c) ? g : h;
      Reflect.set(s, l, c);
    });
  };
  n && j(n);
  const M = (r, l) => {
    const { __locale: c, __messages: s } = e;
    return tt(r, l, c, s);
  }, L = D(() => e.__locale);
  j({ i18n: M, currentLocale: L });
  const { dataSource: q, dataSourceMap: F, reloadDataSource: A } = St(
    (t = o.dataSource) != null ? t : { list: [], dataHandler: void 0 },
    h,
    i
  );
  return Object.keys(F).filter((r) => !(r in g)).forEach((r) => g[r] = U()), j({ dataSource: q, dataSourceMap: F, reloadDataSource: A }), ve(A), {
    scope: h,
    addToScope: j
  };
}
const Rt = z({
  render(e) {
    var o;
    return $("div", { class: "lc-page", props: e }, (o = this == null ? void 0 : this.$slots) == null ? void 0 : o.default);
  }
}), Pt = z({
  props: de,
  __renderer__: !0,
  setup(e) {
    const { renderComp: o, componentsRef: n, scope: i } = Ct(e);
    return window.__pageContext = i, () => {
      const { __schema: u } = e, { value: _ } = n;
      return o(u, null, _.Page || Rt);
    };
  }
}), Me = {
  PageRenderer: Pt
};
class Lt {
  constructor() {
    oe(this, "renderers", { ...Me });
    oe(this, "configProvider", null);
  }
  setConfigProvider(o) {
    this.configProvider = o;
  }
  getConfigProvider() {
    return this.configProvider;
  }
  setRenderers(o) {
    this.renderers = o;
  }
  getRenderers() {
    return this.renderers;
  }
}
const Oe = new Lt(), Ht = z({
  name: "VueRenderer",
  props: {
    scope: {
      type: Object,
      default: void 0
    },
    schema: {
      type: Object,
      required: !0
    },
    components: {
      type: Object,
      required: !0
    },
    designMode: {
      type: String,
      default: "live"
    },
    device: {
      type: String,
      default: void 0
    },
    locale: {
      type: String,
      default: void 0
    },
    messages: {
      type: Object,
      default: () => ({})
    },
    requestHandlersMap: {
      type: Object,
      default: () => ({})
    },
    getNode: {
      type: Function,
      default: void 0
    },
    onCompGetCtx: {
      type: Function,
      default: void 0
    }
  },
  setup(e) {
    const o = (p, h) => {
      var m;
      h && ((m = e.onCompGetCtx) == null || m.call(e, p, h));
    }, n = (p) => {
      var h, m;
      return (m = (h = e.getNode) == null ? void 0 : h.call(e, p)) != null ? m : null;
    }, i = D(() => ({
      ...Oe.getRenderers(),
      ...e.components
    })), u = ce(e.schema), _ = Qe(() => {
      const p = e.schema.id, h = p && n(p);
      if (h) {
        const m = et(h);
        m && (u.value = m);
      }
    }), b = () => {
      const { value: p } = i, { scope: h, locale: m, messages: g, designMode: S, requestHandlersMap: y } = e, O = u.value;
      if (!O)
        return null;
      const { componentName: w } = O;
      let v = p[w] || p[`${w}Renderer`];
      return v && !v.__renderer__ && (v = Me[`${w}Renderer`]), v ? $(v, {
        key: O.__ctx ? `${O.__ctx.lceKey}_${O.__ctx.idx || "0"}` : O.id,
        props: {
          __scope: h,
          __schema: O,
          __locale: m,
          __messages: g,
          __components: p,
          __designMode: S,
          __requestHandlersMap: y,
          __getNode: n,
          __rerender: _,
          __triggerCompGetCtx: o
        }
      }) : null;
    };
    return () => {
      const { device: p, locale: h } = e, m = Oe.getConfigProvider();
      return m ? $(m, {
        props: {
          device: p,
          locale: h,
          scopedSlots: { default: b }
        }
      }) : b();
    };
  }
});
export {
  Nt as baseRendererPropKeys,
  Oe as config,
  Ht as default,
  It as leafPropKeys,
  Le as leafProps,
  de as rendererProps,
  _e as useLeaf,
  Ct as useRenderer,
  jt as useRootScope
};
